import React from "react"
import { useParams } from "react-router-dom"
import PostDetailView from "@/components/community/PostDetail/PostDetailView"

const PostDetailPage: React.FC = () => {
  const { postId } = useParams<{ postId: string }>()

  if (!postId) {
    return <div>잘못된 접근입니다.</div>
  }

  return <PostDetailView postId={postId} />
}

export default PostDetailPage
